<template>
  <ModalHolder :title="''" m-top="120" m-width="30%" m-height="35vh" :is-show="show">
    <template slot="mheader">
      <div style="height: 20px;">
        <span style="position:absolute;right:15px;top:15px" @click="dismissModal()">
          <Icon size="20" type="close-circled"></Icon>
        </span>
        <strong>Invitation</strong>
      </div>
    </template>
    <template slot="mcontent" style="display: flex;">
      <div v-if="invitationInfo.careplan && !loading" style="height: 100%;">
        <p
          align="center"
          style="height: 50%; justify-content: center; align-items: center; display: flex;"
        >
          <progressive-img
            v-if="invitationInfo.careplan"
            style="max-width: 120px; width:120px"
            :src="userDisplayImage(invitationInfo.careplan)"
          />
        </p>
        <h4 align="center" style="height: 50%" v-if="!isAccepted">
          <div v-if="invitationInfo.careplan.type == 'add-ons'">
            <p>You have been prescribed</p>
            <p>{{invitationInfo.careplan.title}}'s</p>
            <p>Add On</p>
          </div>
          <div v-else>
            <p>You have been invited to join</p>
            <p>{{invitationInfo.careplan.title}}'s</p>
          </div>
        </h4>
        <h4 v-else>
          <p>You have already accepted this invitation</p>
        </h4>
      </div>
      <div class="loading" v-if="loading">
        <Spin fix>
          <Icon type="load-c" class="demo-spin-icon-load"></Icon>
          <div>Loading...</div>
        </Spin>
      </div>
      <div
        class="error"
        v-else-if="!invitationInfo.careplan && !loading"
      >An error occured while loading invitation info</div>
    </template>
    <template slot="mfooter">
      <div v-if="!isAccepted">
        <Button
          type="error"
          :loading="rejectLoading"
          :disabled="loading || !invitationInfo.careplan"
          style="float: left;"
          @click="rejectInvite()"
        >Decline</Button>
        <Button
          type="primary"
          :loading="acceptLoading"
          :disabled="loading || !invitationInfo.careplan"
          @click="acceptInvite()"
        >Accept</Button>
      </div>
      <div v-else>
        <Button @click="proceed()">Proceed</Button>
      </div>
    </template>
  </ModalHolder>
</template>

<script>
import Utils from "@/utils.js";
import axios from "axios";
import * as API from "@/endpoints";
import ModalHolder from "@/components/ModalHolderComponent";
import _ from "lodash";

export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    invitationId: {
      type: String
    }
  },
  data() {
    return {
      invitationInfo: {},
      loading: false,
      acceptLoading: false,
      rejectLoading: false
    };
  },
  watch: {
    show(n) {
      if (n) this.loadInvitationInfo();
      else {
        this.loading = false;
        this.invitationInfo = {};
      }
    }
  },
  methods: {
    proceed() {
      switch (this.invitationInfo.careplan.type) {
        case "add-ons":
          this.$router.push(`/${this.$route.params.brandSlug}/library/`);
          break;
        default:
          this.$router.push(
            `/${this.$route.params.brandSlug}/resources/${this.invitationInfo.careplan.id}`
          );
          break;
      }
      this.dismissModal();
    },
    acceptInvite() {
      this.acceptLoading = true;
      this.$store
        .dispatch("user/acceptPrescription", {
          item: {
            id: this.invitationId
          }
        })
        .catch(err => {
          this.$Message({
            closable: true,
            durationInSec: 3,
            title: { content: "Error" },
            icon: "alert",
            message: { content: "Unable to accept invitation" }
          });
        })
        .finally(() => {
          this.acceptLoading = false;
          this.dismissModal();
          if (this.invitationInfo.careplan.type != "add-ons")
            this.$router.push("resources/" + this.invitationInfo.careplan.id);
          else this.$router.push("library");
        });
    },
    rejectInvite() {
      this.rejectLoading = true;
      if (this.invitationInfo.careplan.type == "add-ons") {
        this.rejectLoading = false;
        this.dismissModal();
      } else {
        this.$store
          .dispatch("user/declinePrescription", {
            item: {
              id: this.invitationId
            }
          })
          .catch(err => {
            this.$Message({
              closable: true,
              durationInSec: 3,
              title: { content: "Error" },
              icon: "alert",
              message: { content: "Unable to reject invitation" }
            });
          })
          .finally(() => {
            this.rejectLoading = false;
            this.dismissModal();
          });
      }
    },
    loadInvitationInfo() {
      this.loading = true;
      axios
        .get(API.endpoints.prescribe + "/careplan/" + this.invitationId)
        .then(res => (this.invitationInfo = res.data))
        .finally(() => (this.loading = false));
    },
    dismissModal() {
      this.$emit("close");
      this.$router.replace({
        query: {
          ...this.$route.query,
          group_invite_code: null
        }
      });
    },
    userDisplayImage(group) {
      return Utils.getDisplayImage("group", group, "medium");
    }
  },
  computed: {
    isAccepted() {
      return _.get(this.invitationInfo, "is_accepted", false);
    }
  },
  components: { ModalHolder }
};
</script>

<style lang="scss" scoped>
.loading {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .ivu-spin {
    top: 50%;
    height: fit-content;
  }
}
.error {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}
</style>

